module.exports = __webpack_public_path__ + "media/snake-gameplay.272c11e9.mp4";